
































































































































































































import Vue from "vue";
import Component, { mixins } from "vue-class-component";
import { Emit, Provide, Watch } from "vue-property-decorator";
import { MenuItem } from "@/types";
import VueRouter, { Route } from "vue-router";
import Cookies from "js-cookie";
import { ShowSnackbar } from "@/store/modules/showSnackbar/types";
import { State } from "vuex-class";
import AxiosMixin from "../../mixins/axiosMixin";

@Component
export default class Main extends mixins(AxiosMixin) {
  @State("showsnackbar") snack!: ShowSnackbar;

  private showFlag = false;

  private menuItems: MenuItem[] = [
    {
      id: 0,
      icon: "dynamic_feed",
      url: "/",
      name: "確定済実績管理"
    },
    {
      id: 1,
      icon: "mdi-calculator",
      url: "/aggregate",
      name: "請求データ集計"
    },
    {
      id: 2,
      icon: "mdi-table-account",
      url: "/medical/merge",
      name: "医療請求管理"
    },
    {
      id: 3,
      icon: "mdi-table-account",
      url: "/medical/summarytable",
      name: "総括表管理"
    },
    {
      id: 4,
      icon: "mdi-table-account",
      url: "/care/merge",
      name: "介護請求管理"
    },
    {
      id: 5,
      icon: "mdi-file-send-outline",
      url: "/care/transmission",
      name: "介護請求伝送"
    },
    {
      id: 6,
      icon: "mdi-table-account",
      url: "/userinvoice?only=false",
      name: "利用者請求管理"
    }
  ];

  //   private innerUserInvouceMenuItems: MenuItem[] = [
  //     {
  //       id: 5,
  //       icon: "mdi-calendar",
  //       url: "/userinvoice?only=false",
  //       name: "医療・介護"
  //     },
  //     {
  //       id: 6,
  //       icon: "mdi-calendar",
  //       url: "/medical/userinvoice?only=false",
  //       name: "医療"
  //     },
  //     {
  //       id: 7,
  //       icon: "mdi-calendar",
  //       url: "/care/userinvoice?only=false",
  //       name: "介護"
  //     }
  //   ];

  private innerReceiptDashboardMenuItems: MenuItem[] = [
    {
      id: 8,
      icon: "mdi-format-list-bulleted",
      url: "/billinglist",
      name: "請求一覧"
    },
    {
      id: 9,
      icon: "mdi-format-list-bulleted",
      url: "/billinglistdetails",
      name: "請求一覧（詳細）"
    },
    {
      id: 10,
      icon: "mdi-format-list-bulleted",
      url: "/account_transfer",
      name: "口座振替データ管理",
      classes: ["account-transfer-manage-menu-label"]
    }
  ];

  private innerSettingItems: MenuItem[] = [
    {
      id: 11,
      icon: "mdi-wallet-travel",
      url: "/payment_manage",
      name: "入金管理"
    },
    {
      id: 12,
      icon: "mdi-message-alert-outline",
      url: "/all_no_output",
      name: "未処理データ一覧"
    },
    {
      id: 13,
      icon: "mdi-cog-outline",
      url: "/settings",
      name: "設定"
    }
  ];

  private drawer = true;

  private menuActive = 0;

  private userInvoiceActive = true;

  private receiptDashboardActive = true;

  private office_name = window.office_name;

  private user_name = window.user_name;

  private mode = window.mode;

  private title_text = "";

  @Provide() navigationManage = this.setMenuActive;

  mounted() {
    this.getShowFlag();
    this.setMenuActive();
  }

  @Watch("$route")
  handleRoute(before: Route, after: Route) {
    if (before.path !== after.path) {
      this.setMenuActive();
    }
  }

  //   private get userInvoiceMenuItems(): MenuItem[] {
  //     return this.innerUserInvouceMenuItems;
  //   }

  //介護請求伝送メニュー表示判定
  private getShowFlag() {
    this.postJsonCheck(
      window.base_url + "/api/office/menu_show_flag/get",
      {},
      res => {
        this.showFlag = res.data.menu_show_flag;
      }
    );
  }

  private showMenu(item: MenuItem) {
    // 伝送のみ表示・非表示の判定必要
    if (item.url === "/care/transmission") {
      return this.showFlag;
    }
    return true;
  }

  private get receiptDashboardMenuItems(): MenuItem[] {
    return this.innerReceiptDashboardMenuItems;
  }

  private get settingItems(): MenuItem[] {
    return this.innerSettingItems;
  }

  private setMenuActive() {
    const url = window.location.href;
    const results = url.match(/^https?:\/\/.*?(\/[^?]*).*/);
    if (results && results.length > 1) {
      let hit = false;
      const path = results[1];
      this.menuItems.forEach(item => {
        if (path === item.url.replace("?only=false", "")) {
          this.userInvoiceActive = false;
          this.receiptDashboardActive = false;
          this.menuActive = item.id;
          this.title_text = item.name;
          hit = true;
        }
      });
      //   if (!hit) {
      //     this.userInvoiceMenuItems.forEach(item => {
      //       if (path === item.url.replace("?only=false", "")) {
      //         this.userInvoiceActive = true;
      //         this.receiptDashboardActive = false;
      //         this.menuActive = item.id;
      //         this.title_text = "利用者請求管理 | " + item.name;
      //         hit = true;
      //       }
      //     });
      //   }
      if (!hit) {
        this.receiptDashboardMenuItems.forEach(item => {
          if (path === item.url.replace("?only=false", "")) {
            this.userInvoiceActive = false;
            this.receiptDashboardActive = true;
            this.menuActive = item.id;
            this.title_text = "レセプトダッシュボード | " + item.name;
            hit = true;
          }
        });
      }
      if (!hit) {
        this.settingItems.forEach(item => {
          if (path === item.url) {
            this.userInvoiceActive = false;
            this.receiptDashboardActive = false;
            this.menuActive = item.id;
            this.title_text = item.name;
            hit = true;
          }
        });
      }
    }
  }

  private linkto(item: MenuItem) {
    this.$router.push(item.url);
  }

  private clickChangeOfficeBtn() {
    this.selectOff();
  }

  private logout() {
    window.token = "";
    Cookies.set("token", "");
    window.reftoken = "";
    Cookies.set("reftoken", "");
    window.office_name = "";
    Cookies.set("office_name", "");
    Cookies.set("isAgree", "");
    localStorage.removeItem("yearmonth");
    localStorage.removeItem("yearmonths");
    location.href = "/";
    window.close();
  }

  @Emit("selectOff")
  private selectOff() {
    return;
  }
}
